import { useEffect, useRef, useCallback } from "react";

const useInactivityTimeout = (timeoutDuration, onTimeout) => {
    const timeoutRef = useRef();

    const resetTimeout = useCallback(() => {
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
            sessionStorage.setItem("lastVisitedPath", window.location.pathname);
            onTimeout();
        }, timeoutDuration);
    }, [onTimeout, timeoutDuration]);

    useEffect(() => {
        const events = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];

        events.forEach((event) => window.addEventListener(event, resetTimeout));
        resetTimeout(); // start timer on mount

        return () => {
            events.forEach((event) => window.removeEventListener(event, resetTimeout));
            clearTimeout(timeoutRef.current);
        };
    }, [resetTimeout]);
};

export default useInactivityTimeout;
